import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ResponsivePaddingWrapper, {
  ResponsiveFlexDirection,
} from '../../../../component/responsive/responsivePaddingWrapper';
import UserBaseProfile from './component/UserBaseProfile';
import IntroSection from '../../../../component/introSection';
import Letter from './component/Letter';
import { Member } from '../../../../types/member';
import { useMobile } from '../../../../hook/usePlatform';
import { defaultBorder, lineColor } from '../../../../util/colors';
import AcceptButton from './component/AcceptButton';
import QuestionAndAnswer from './component/QuestionAndAnswer';
import ReturnToRecommend from './component/ReturnToRecommend';

const MemberDetailPage:React.FC = (props) => {
  const { state } = useLocation();
  const { user, historyId, acceptState } :{ user:Member, historyId:number, acceptState:boolean | null } = state;
  const navigate = useNavigate();
  const isMobile = useMobile();
  useEffect(() => {
    if (!user) {
      navigate('/recommend', { replace: true });
    }
  }, [state]);
  if (!user) {
    return null;
  }
  return (
    <div>
      <IntroSection title="[회원프로필]" content="프로필은 추천일 기준 7일동안 조회할 수 있어요" />
      <ResponsivePaddingWrapper style={{ borderTop: defaultBorder }}>

        <ResponsiveFlexDirection style={{ justifyContent: isMobile ? 'center' : 'space-between' }}>
          <div
            style={{
              flex: 1,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingInline: isMobile ? 30 : 70,
                paddingBlock: isMobile ?  30 : 120,
              }}
            >
              <UserBaseProfile user={user} />
              <Letter value={user?.additionalInfo?.public.managerNote.matchingNote ?? ''} />
              <AcceptButton historyId={historyId} showButton={acceptState === null || acceptState === undefined}  />
              <ReturnToRecommend />
            </div>
          </div>
          {!isMobile ? (
            <div
              style={{
                position: 'absolute',
                left: '50%',
                height: '100%',
                width: '1px',
                backgroundColor: lineColor,
              }}
            />
          ) : null}
          <div style={{ flex: 1 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMobile ? 'center' : 'flex-start',
                justifyContent: 'center',
                paddingInline: isMobile ? 30 : 70,
                paddingBlock: isMobile ? 30 : 120,
              }}
            >
              <QuestionAndAnswer
                number={1}
                title="나의 매력"
                value={user.additionalInfo?.public?.question?.myCharm ?? ''}
              />
              <QuestionAndAnswer
                number={2}
                title="나의 하루 루틴"
                value={user.additionalInfo?.public?.question?.myDailyLife ?? ''}
              />
              <QuestionAndAnswer
                number={3}
                title="좋아하는 음식"
                value={user.additionalInfo?.public?.question?.myFavoriteFood ?? ''}
              />

              <QuestionAndAnswer
                number={4}
                title="좋아하는 영화"
                value={user.additionalInfo?.public?.question?.myFavoriteMovie ?? ''}
              />
              <QuestionAndAnswer
                number={5}
                title="가장 힘들었던 순간"
                value={user.additionalInfo?.public?.question?.myHardestTrial ?? ''}
              />
              <QuestionAndAnswer
                number={6}
                title="미래의 연인에게.."
                value={user.additionalInfo?.public?.question?.sayToFutureLover ?? ''}
              />
              <QuestionAndAnswer
                number={7}
                title="이런 분을 만나면 설레어요"
                value={user.additionalInfo?.public?.question?.myIdeal ?? ''}
              />
            </div>
          </div>
        </ResponsiveFlexDirection>
      </ResponsivePaddingWrapper>
    </div>
  );
};

export default MemberDetailPage;
